module.exports = __webpack_public_path__ + "img/success-order.15ce0d6b.svg";